export default [
    {
      path: '/kills',
      name: 'Kill-list',
      component: () => import('@/components/adm/kill/KillsList.vue'),
      meta: {
        title: "Controle Leiteiro > Registro de Baixas"
      }
    },
  ]